import React from "react";
import PropTypes from "prop-types";
import PredioSolvencia from "@/components/Predios/PredioSolvencia";

const Step3 = (props) => {
    const { solvencia, setSolvencia, isLoading } = props;

    return (
        <>
            {isLoading ? (
                <div className="flex h-full flex-col items-center justify-center text-center">
                    <div className="mb-4 h-10 w-10 animate-spin rounded-full border-b-2 border-t-2 border-blue-500"></div>
                    <p className="select-none text-lg font-medium text-gray-700">
                        Cargando requisitos...
                    </p>
                </div>
            ) : (
                <PredioSolvencia value={solvencia} onChange={setSolvencia} />
            )}
        </>
    )
}

Step3.propTypes = {
    solvencia: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    setSolvencia: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
}

export default Step3;
